"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var decorated_number_1 = __importDefault(require("../decorated-number"));
var number_part_1 = require("../number-part");
var decorator = {
    decorate: function (phoneNumber, extensionConfig) {
        if (extensionConfig === void 0) { extensionConfig = { decoratedDelimiter: " ext. ", delimiter: "x" }; }
        var decoratedNumber = new decorated_number_1.default([
            number_part_1.internationalDecorativePart("+"),
            number_part_1.countryCodePart("1"),
            number_part_1.internationalDecorativePart(" "),
        ]);
        // In NANP countries users will often type the local number with a precending 1, in normalizng
        // the data to be passed through to the decorator we always prepend the country code, this can
        // result in cases where the user has the country code '1' and the trunk no '1' at the start
        // of their input. We'll strip it away twice. No local NANP number can start with 1.
        if (phoneNumber.charAt(0) === "1") {
            phoneNumber = phoneNumber.substring(1);
        }
        if (phoneNumber.charAt(0) === "1") {
            phoneNumber = phoneNumber.substring(1);
        }
        var inExtension = false;
        for (var i = 0; i < phoneNumber.length; ++i) {
            var digit = phoneNumber[i];
            if (i === 0 && phoneNumber.length > 2) {
                decoratedNumber.parts.push(number_part_1.decorativePart("("));
            }
            if (i >= 0 && i <= 2) {
                decoratedNumber.parts.push(number_part_1.areaCodePart(digit));
            }
            else if (digit === extensionConfig.delimiter) {
                inExtension = true;
                decoratedNumber.parts.push(number_part_1.extensionDecorativePart(extensionConfig));
            }
            else if (inExtension) {
                decoratedNumber.parts.push(number_part_1.extensionPart(digit));
            }
            else {
                decoratedNumber.parts.push(number_part_1.numberPart(digit));
            }
            if (i === 2) {
                decoratedNumber.parts.push(number_part_1.decorativePart(")"));
                decoratedNumber.parts.push(number_part_1.decorativePart(" "));
            }
            if (i === 5) {
                decoratedNumber.parts.push(number_part_1.decorativePart("-"));
            }
        }
        return decoratedNumber;
    },
};
exports.default = decorator;
//# sourceMappingURL=nanp.js.map